const ec2Vpcs = `<?xml version="1.0" encoding="UTF-8"?>
<DescribeVpcsResponse xmlns="http://ec2.amazonaws.com/doc/2016-11-15/">
    <requestId>83a3d8f9-e17d-41b9-9734-e36c572715f2</requestId>
    <vpcSet>
        <item>
            <vpcId>vpc-7d4a2818</vpcId>
            <ownerId>210811600188</ownerId>
            <state>available</state>
            <cidrBlock>172.30.0.0/20</cidrBlock>
            <cidrBlockAssociationSet>
                <item>
                    <cidrBlock>172.30.0.0/20</cidrBlock>
                    <associationId>vpc-cidr-assoc-c08773a9</associationId>
                    <cidrBlockState>
                        <state>associated</state>
                    </cidrBlockState>
                </item>
            </cidrBlockAssociationSet>
            <dhcpOptionsId>dopt-3a8d7f5f</dhcpOptionsId>
            <tagSet>
                <item>
                    <key>Name</key>
                    <value>HCL-VPC1</value>
                </item>
            </tagSet>
            <instanceTenancy>default</instanceTenancy>
            <isDefault>false</isDefault>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
        <item>
            <vpcId>vpc-62720a04</vpcId>
            <ownerId>210811600188</ownerId>
            <state>available</state>
            <cidrBlock>10.0.0.0/16</cidrBlock>
            <cidrBlockAssociationSet>
                <item>
                    <cidrBlock>10.0.0.0/16</cidrBlock>
                    <associationId>vpc-cidr-assoc-17412d7f</associationId>
                    <cidrBlockState>
                        <state>associated</state>
                    </cidrBlockState>
                </item>
            </cidrBlockAssociationSet>
            <dhcpOptionsId>dopt-37dcc655</dhcpOptionsId>
            <tagSet>
                <item>
                    <key>Name</key>
                    <value>SGWS</value>
                </item>
            </tagSet>
            <instanceTenancy>default</instanceTenancy>
            <isDefault>false</isDefault>
            <blockPublicAccessStates>
                <internetGatewayBlockMode>off</internetGatewayBlockMode>
            </blockPublicAccessStates>
        </item>
    </vpcSet>
</DescribeVpcsResponse>`

export default ec2Vpcs;
